import { makeAutoObservable } from 'mobx';
import { IOAuthCredentialsParams } from '../../../../../models/IntegrationsTypes';
import { ICredentialsStore } from '../integration-store';

interface IEventMessage {
    type: string;
    [payloadKey: string]: any;
}

const CLOSE_INTERVAL = 50;

class OauthCredentialsStore implements ICredentialsStore {
    private _window = {} as Window;
    private _intervalId: any = undefined;
    private _messageHandler?: (event: IEventMessage) => void;

	constructor(private _credentialsParams: IOAuthCredentialsParams) {
        makeAutoObservable(this);
	} 

    // Handle case when user didn't finish authorization flow and closed window
    private _listenToWindowClosed(reject: (reason?: any) => void) {
        /** make sure to always clear interval before starting new one */
        clearInterval(this._intervalId);

        this._intervalId = setInterval(() => { 
            if (!this._window.closed) {
                return;
            }
            clearInterval(this._intervalId);
            reject(new Error('Authorization interrupted, window was closed before finishing the process'));
        }, CLOSE_INTERVAL);
    }

    private _handleMessage(event: IEventMessage, resolve: (value: unknown) => void, reject: (reason?: any) => void) {
        if (event.data?.type !== 'OAUTH_RESPOSE') {
            return;
        }
        
        this._window.close();
        window.removeEventListener('message', this._messageHandler as (event: IEventMessage) => void, false);
            
        if (event.data.payload?.code) {
            return resolve(event.data.payload.code);
        }

        return reject(new Error('Failed to receive code'));
    }
    
    /** ICredentialsStore implementation ************/
    public async getCredentials() {

        if (this._messageHandler) {
            window.removeEventListener('message', this._messageHandler, false);
        }

        return new Promise((resolve, reject) => {
            this._window = window.open(this._credentialsParams.oauth_url, '', 'width=800,height=600,resizeable,scrollbars') as Window;
            
            this._messageHandler = (event: IEventMessage) => {
                this._handleMessage(event, resolve, reject);
            };

            window.addEventListener('message', this._messageHandler, false);

            this._listenToWindowClosed(reject);
        });
    }
}

export default OauthCredentialsStore;
